const skills = {
  1: [
    {
      title: "C#",
      level: 6,
    },
    {
      title: "C++",
      level: 4,
    },
    {
      title: "JavaScript",
      level: 3,
    },
    {
      title: "Python",
      level: 2,
    },
    {
      title: "Unity 2D",
      level: 6,
    },
    {
      title: "Unity 3D",
      level: 5,
    },
    {
      title: "Unreal Engine",
      level: 4,
    },
    {
      title: "Godot",
      level: 2,
    },
  ],
  2: [
    {
      title: "Blender",
      level: 2,
    },
    {
      title: "Aseprite",
      level: 5,
    },
    {
      title: "Audacity/Reaper",
      level: 3,
    },
    {
      title: "Game Physics",
      level: 5,
    },
    {
      title: "AI & Pathfinding",
      level: 5,
    },
    {
      title: "AnimationSystems",
      level: 4,
    },
    {
      title: "UI/UX for Games",
      level: 6,
    },
    {
      title: "Shaders & VFX",
      level: 3,
    },
    {
      title: "Level Design",
      level: 6,
    },
    {
      title: "Audio Integration",
      level: 4,
    },
    {
      title: "Multiplayer/Networking",
      level: 2,
    },
  ],
};

export default skills;